import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_serialnumbers_non_fixed_weight_by_completed_shipmentId_materialIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shipmentId: number, materialId: number }): 
  Promise<{ result: { TotalGrossWeight?: number, TotalNetWeight?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipmentId)) {
      $missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shipmentId: number, materialId: number    }) {
        if(isNil($inParams.shipmentId)) {
          return true; 
        }
        if(isNil($inParams.materialId)) {
          return true; 
        }
      return false;
    }
}
